import {InjectionToken} from '@angular/core';

export const TISA_SPINNER_COMPONENT = new InjectionToken('Provides spinner component.');
